import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  username: '',
  email: '',
  password: '',
  userLevel: null,
  userType: null,
  userId: null,
  accessToken: '',
  refreshToken: '',
  changePassword: null,
  partner: '',
  allowPersonalinfo: 0,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initialize: () => initialState,
    changeField: (state, { payload: { key, value } }) => {
      state[key] = value;
    },
  },
});

export const { initialize, changeField } = authSlice.actions;

export default authSlice.reducer;
